import { render, staticRenderFns } from "./CrmUpdate.vue?vue&type=template&id=d6229528&scoped=true"
import script from "./CrmUpdate.vue?vue&type=script&lang=js"
export * from "./CrmUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6229528",
  null
  
)

export default component.exports